<h4 class="esf-heading esf-heading--low-level esf-action-heading esf-action-heading--low-level esf-action-heading--tile">
  <span i18n='Club section title@@clubOverviewComponent.sectionHeading.tixxRelatedSettings' class="esf-action-heading__text">Tixx related settings</span>
  <span class="esf-action-heading__actions">
    <span class="esf-action-heading__action">
      <button class="esf-button esf-button--simple"
              (click)="clubOverviewService.toggleAllModal(false);clubOverviewService.toggleEditClubCommunicationModal(true)"
              [edsTooltip]="tooltipTranslations.i18nEdit">
        <svg class="esf-icon esf-button__icon" width="16" height="16">
          <use xlink:href="#esf-icon-edit"></use>
        </svg>
        <span class="esf-button__icon-text"></span>
      </button>
    </span>
  </span>
</h4>
<div class="esf-info-tile" style="flex: 1;">
  <div class="esf-info-tile__content">
    <div class="esf-icon-and-text esf-icon-and-text--xs">
      <span i18n='@@clubOverviewComponent.text.membershipGroupId'>Membership group id</span>:
      <div class="esf-icon-and-text__text" style="padding-left: 0.5rem;">{{ selectedClub.tixxMembershipGroupId }}</div>
    </div>
    <div class="esf-icon-and-text esf-icon-and-text--xs">
      <span i18n='@@clubOverviewComponent.text.externalSsoActivated'>External SSO activated</span>:
      <div class="esf-icon-and-text__text" style="padding-left: 0.5rem;">{{ getTranslatedStatus(selectedClub.tixxExternalSso) }}</div>
    </div>
    <div class="esf-icon-and-text esf-icon-and-text--xs">
      <span i18n='@@clubOverviewComponent.text.mergesViaTixxCrm'>Merges via Tixx-CRM</span>:
      <div class="esf-icon-and-text__text" style="padding-left: 0.5rem;">{{ getTranslatedStatus(selectedClub.tixxCustomerMergeAllowed) }}</div>
    </div>
  </div>
</div>
